<template>
    <div id="tasks">
        <AppBreadCrumb :paths="[{ title: 'Tasks' }]" :select="true" :show-subjects="true"></AppBreadCrumb>
        <div>
            <div class="head-bar">
                <div class="batch-operation" v-if="batchOperation()">
                    <a-input-group compact>
                        <a-button :value="'test'">
                            <div style="display: flex; align-items: center; gap: 5px">
                                <a-checkbox
                                    class="kanban-checkbox"
                                    :indeterminate="checkedAllTasks()"
                                    :checked="checkedAllTask"
                                    @change="changeCheckedTasks"
                                />
                            </div>
                        </a-button>
                        <a-button :value="'test'">
                            <div style="display: flex; align-items: center; gap: 5px" @click="changeStageModal = true">
                                <div class="material-icons" style="font-size: 20px">table_chart</div>
                                Change Stage
                            </div>
                        </a-button>
                        <a-button :value="'xd'">
                            <div style="display: flex; align-items: center; gap: 5px" @click="deleteMultipleTasksModal = true">
                                <div class="material-icons" style="font-size: 20px">delete</div>
                                Delete
                            </div>
                        </a-button>
                    </a-input-group>
                </div>
                <div v-else>
                    <a-radio-group v-model:value="type">
                        <a-radio-button v-for="option of options" :key="option.value" :value="option.value">{{
                            option.label
                        }}</a-radio-button>
                    </a-radio-group>
                </div>
                <div style="display: flex; align-items: center; gap: 10px">
                    <a-select
                        v-if="type === 'kanban'"
                        class="classic-new-select"
                        v-model:value="workflowId"
                        :options="getWorkflows()"
                    />
                    <a-dropdown-button @click="createTask" class="menu-button">
                        Create
                        <template #overlay>
                            <a-menu @click="createWorkflow">
                                <a-menu-item key="1"> Workflow </a-menu-item>
                            </a-menu>
                        </template>
                    </a-dropdown-button>
                    <div
                        style="display: flex; align-items: center; justify-content: center; user-select: none"
                        @click="openTaskSettings"
                    >
                        <div class="material-icons">settings</div>
                    </div>
                    <a-dropdown :placement="'bottomRight'" class="more-also" @click.prevent>
                        <div class="material-icons">more_vert</div>
                        <template #overlay>
                            <a-menu>
                                <a-menu-item> Export to CSV </a-menu-item>
                            </a-menu>
                        </template>
                    </a-dropdown>
                </div>
            </div>
            <div class="board">
                <TaskDraggable v-if="workflowId && type === 'kanban'" :workflowId="workflowId" />
                <KanbanList v-if="type === 'list'" />
            </div>
        </div>
        <a-modal
            :visible="deleteMultipleTasksModal"
            icon="exclamation-circle"
            title="Delete Task"
            @cancel="deleteMultipleTasksModal = false"
        >
            <p>Are you sure you want to delete these tasks?</p>
            <template #footer>
                <a-button key="back" @click="deleteMultipleTasksModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteMultipleTasks">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
        <Modal2
            v-if="changeStageModal"
            @cancel="changeStageModal = false"
            :title="'Change Stage'"
            :description="'1 selected candidate(s)'"
            :ok-text="'Save'"
            @ok="changeTaskPipeline"
        >
            <div class="radio-group-container">
                <a-radio-group v-model:value="selectedPipelineId">
                    <a-radio v-for="pipeline in defaultWorkflow.pipeline" :key="pipeline._id" :value="pipeline._id">
                        {{ pipeline.name }}
                    </a-radio>
                </a-radio-group>
            </div>
        </Modal2>
    </div>
</template>
<script>
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import { mapActions, mapState } from "vuex";
import KanbanList from "../../../components/task/KanbanList.vue";
import TaskDraggable from "./components/TaskDraggable.vue";
import { getOrUpdateFilters } from "../../../utils/persistenceStorage";
import SupsisButton from "../../../components/common/SupsisButton.vue";
import Modal2 from "../../../components/common/Modal2.vue";

const filters = getOrUpdateFilters("tasks");
export default {
    components: {
        AppBreadCrumb,
        KanbanList,
        TaskDraggable,
        SupsisButton,
        Modal2,
    },
    data() {
        return {
            type: filters.type || "kanban",
            options: [
                {
                    value: "kanban",
                    label: "Kanban Board",
                },
                {
                    value: "list",
                    label: "List View",
                },
            ],
            workflowId: null,
            checkedAllTask: false,
            deleteMultipleTasksModal: false,
            changeStageModal: false,
            selectedPipelineId: null,
        };
    },
    computed: {
        ...mapState({
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
            tasks: (state) => state.tasks.tasks,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
            checkedItems: (state) => state.tasks.checkedTasks,
        }),
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            getTasks: "tasks/getTasks",
            deleteTask: "tasks/deleteTask",
            setCheckedTasks: "tasks/setCheckedTasks",
            multipleTaskDelete: "tasks/multipleTaskDelete",
            mulitpleTaskMove: "tasks/mulitpleTaskMove",
        }),
        getWorkflows() {
            return Object.keys(this.workflows).map((workflow) => ({
                value: this.workflows[workflow]._id,
                label: this.workflows[workflow].title,
            }));
        },
        createWorkflow() {
            this.addNewWindow({
                type: "create-workflow",
                title: "Create Workflow",
            });
        },
        createTask() {
            this.addNewWindow({
                type: "create-task",
                title: "Create Task",
            });
        },
        openTaskSettings() {
            this.addNewWindow({
                type: "task-settings",
                title: "Task Module Settings",
                footer: false,
            });
        },
        batchOperation() {
            return Object.keys(this.checkedItems).filter((key) => this.checkedItems[key]).length > 0;
        },
        checkedAllTasks() {
            const findOne = Object.values(this.tasks)
                .flat()
                .find((task) => this.checkedItems[task._id]);
            const isNotOne = Object.values(this.tasks)
                .flat()
                .find((task) => !this.checkedItems[task._id]);
            if (!isNotOne) this.checkedAllTask = true;
            return !!(findOne && isNotOne);
        },
        changeCheckedTasks(e) {
            const val = e.target.checked;
            for (const task of Object.values(this.tasks).flat()) {
                this.checkedItems[task._id] = val;
            }
            this.setCheckedTasks({
                ...this.checkedItems,
            });
        },
        deleteMultipleTasks() {
            this.multipleTaskDelete(Object.keys(this.checkedItems));
            this.deleteMultipleTasksModal = false;
        },
        changeTaskPipeline() {
            this.mulitpleTaskMove({
                taskIds: Object.keys(this.checkedItems),
                pipelineId: this.selectedPipelineId,
            });
            this.changeStageModal = false;
        },
    },
    mounted() {
        if (this.defaultWorkflow._id) {
            this.workflowId = this.defaultWorkflow._id;
        }
    },
    beforeDestroy() {
        this.setCheckedTasks({});
    },
    watch: {
        defaultWorkflow: {
            deep: true,
            handler(oldVal, newVal) {
                if (!this.$_.isEqual(oldVal, newVal)) {
                    this.workflowId = this.defaultWorkflow._id;
                }
            },
        },
        type() {
            getOrUpdateFilters("tasks", {
                type: this.type,
            });
        },
    },
};
</script>
<style lang="scss">
$color: #ec4b1d;

#tasks {
    .classic-new-select {
        width: 200px;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
        z-index: 1;
        color: white !important;
        background: #ec4b1d;
        border-color: #ec4b1d;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
        background: #ec4b1d;
    }
    .ant-radio-button-wrapper {
        padding: 0px 40px;
        &:hover {
            color: #ec4b1d;
        }
    }
    .head-bar {
        background-color: #f8f9fd;
        border-bottom: 1px solid #e6e9f2;
        padding: 0px 24px;
        min-height: 50px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;

        .head-bar-text {
            font-size: 18px;
            font-weight: 500;
            color: #333338;
        }
        .title {
            line-height: 36px;
            color: #333338;
            font-size: 24px;
            font-weight: 400;
            letter-spacing: 0;
        }
    }
    .actions-button {
        display: flex;
        align-items: center;
        justify-content: center;
        .dropdown {
            padding: 10px;
        }
    }
    .more-also {
        &:hover {
            background-color: rgb(226 226 226 / 53%);
            padding: 3px;
            border-radius: 20px;
        }
        &.material-icons {
            padding: 10px;
        }
    }
    .board {
        width: 100%;
        height: calc(100vh - 145px);
        .board-content {
            padding: 30px;
        }
        .board-todos {
            display: flex;
            height: 100%;
            .control-panel {
                background-color: white;
                width: 260px;
            }
        }
    }
    .radio-group-container {
        display: grid;
        grid-template-columns: 1fr;
    }
}
</style>
